var map = {
	"./Abhinav/images/LoginLogo.svg": [
		27717,
		7717
	],
	"./Agrasen/images/LoginLogo.svg": [
		55793,
		5793
	],
	"./Bhagini/images/LoginLogo.svg": [
		25900,
		5900
	],
	"./DMKJ/images/LoginLogo.svg": [
		48174,
		8174
	],
	"./Deogiri/images/LoginLogo.svg": [
		82845,
		2845
	],
	"./JCOM/images/LoginLogo.svg": [
		53107,
		3107
	],
	"./MOGAVEERA/images/LoginLogo.svg": [
		45565,
		5565
	],
	"./Mahesh/images/LoginLogo.svg": [
		75118,
		5118
	],
	"./NCBM/images/LoginLogo.svg": [
		57358,
		7358
	],
	"./Noble/images/LoginLogo.svg": [
		93444,
		3444
	],
	"./RSSB/images/LoginLogo.svg": [
		64634,
		4634
	],
	"./Samta/images/LoginLogo.svg": [
		40147,
		2528
	],
	"./Satara/images/LoginLogo.svg": [
		21645,
		4026
	],
	"./Sawji/images/LoginLogo.svg": [
		11764,
		1764
	],
	"./Shriraksh/images/LoginLogo.svg": [
		70751,
		751
	],
	"./Suvarna/images/LoginLogo.svg": [
		88532,
		8532
	],
	"./Ucob/images/LoginLogo.svg": [
		82469,
		2469
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 16156;
module.exports = webpackAsyncContext;